// src/pages/DevHub/components/DevAlert.tsx
// Replaces: .dev-alert

import React from 'react';
import { cn } from '../../../lib/utils';

interface DevAlertProps {
    icon?: React.ReactNode;
    children: React.ReactNode;
    className?: string;
}

/*
 * .dev-alert:
 *   display: flex;
 *   gap: 12px;
 *   padding: 16px;
 *   background: #e8f0fe;   (--dev-primary-light)
 *   color: #1557b0;         (--dev-primary-dark)
 *   border-radius: 8px;
 *   font-size: 14px;
 *   line-height: 1.5;
 *
 * .dev-alert svg:
 *   flex-shrink: 0;
 */
const DevAlert: React.FC<DevAlertProps> = ({ icon, children, className }) => (
    <div className={cn(
        'flex gap-[12px] p-[16px]',
        'bg-[#e8f0fe] text-[#1557b0]',
        'rounded-[8px] text-[14px] leading-[1.5]',
        className,
    )}>
        {/* svg / icon: flex-shrink: 0 */}
        {icon && <span className="flex-shrink-0">{icon}</span>}
        {children}
    </div>
);

export default DevAlert;
